import { Alert, AuditEntriesTable, Card, LoadMore, Loading, PageHeader } from '@avrahami/ui';
import { useInfiniteQuery } from '@tanstack/react-query';
import { auditQuery, useStoreTimeZone } from '../api/tenant';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/forms';

/** The store's own activity log, newest first (sign-ins, changes, quote requests moved, …). */
export function ActivityPage() {
  const audit = useInfiniteQuery(auditQuery());
  const timeZone = useStoreTimeZone();
  const entries = audit.data?.pages.flatMap((page) => page.items) ?? [];
  return (
    <>
      <PageHeader title={he.audit.title} />
      <Card>
        {audit.isPending ? <Loading /> : null}
        {audit.isError ? <Alert>{errorMessage(audit.error)}</Alert> : null}
        {audit.isSuccess && entries.length === 0 ? (
          <p className="text-sm text-slate-500">{he.audit.empty}</p>
        ) : null}
        {entries.length > 0 ? (
          <AuditEntriesTable
            entries={entries}
            actionLabels={he.actions}
            words={he.audit}
            timeZone={timeZone}
          />
        ) : null}
        <LoadMore
          hasMore={audit.hasNextPage}
          busy={audit.isFetchingNextPage}
          onMore={() => {
            void audit.fetchNextPage();
          }}
        />
      </Card>
    </>
  );
}
